
export const services = {
  hero: {
    title: 'Nuestros Servicios',
    subtitle: 'Soluciones de automatización diseñadas específicamente para negocios con agenda de citas. Cada servicio se adapta a tus necesidades y escala con tu crecimiento.'
  },
  list: [
    {
      title: 'Chatbot Inteligente',
      description: 'Asistente virtual que atiende a tus clientes 24/7 en WhatsApp y redes sociales, responde preguntas frecuentes y gestiona reservas automáticamente.',
      deliverables: [
        'Configuración de chatbot en WhatsApp Business',
        'Integración con Instagram, Facebook Messenger y web',
        'Respuestas personalizadas según tu negocio',
        'Gestión automática de consultas y reservas',
        'Panel de control con métricas en tiempo real'
      ]
    },
    {
      title: 'Sistema de Gestión de Agenda',
      description: 'Plataforma centralizada que organiza todas tus citas, sincroniza calendarios y optimiza la disponibilidad de tu equipo.',
      deliverables: [
        'Calendario inteligente con disponibilidad en tiempo real',
        'Sincronización automática con Google Calendar',
        'Gestión de múltiples profesionales y servicios',
        'Confirmación automática de citas',
        'Historial completo de reservas y clientes'
      ]
    },
    {
      title: 'Desarrollo de Páginas Web',
      description: 'Sitios web profesionales optimizados para conversión, con sistema de reservas integrado y diseño responsive adaptado a tu marca.',
      deliverables: [
        'Diseño web personalizado y responsive',
        'Sistema de reservas online integrado',
        'Optimización SEO para búsquedas locales',
        'Formularios de contacto y consulta',
        'Hosting y mantenimiento incluido'
      ]
    },
    {
      title: 'Automatización de Recordatorios',
      description: 'Sistema inteligente de notificaciones que reduce los no-shows mediante recordatorios automáticos por WhatsApp, SMS y email.',
      deliverables: [
        'Recordatorios automáticos 24h antes de la cita',
        'Confirmación de asistencia con un clic',
        'Notificaciones por WhatsApp, SMS y email',
        'Reprogramación automática de citas canceladas',
        'Seguimiento post-cita para feedback'
      ]
    },
    {
      title: 'Consultoría en Automatización',
      description: 'Análisis completo de tu negocio y diseño de estrategia personalizada para optimizar procesos y maximizar resultados.',
      deliverables: [
        'Auditoría de procesos actuales',
        'Diseño de flujos de automatización personalizados',
        'Recomendaciones de herramientas y tecnologías',
        'Plan de implementación paso a paso',
        'Formación para tu equipo'
      ]
    }
  ],
  integrations: {
    title: 'Integraciones a Medida',
    description: 'Conectamos tu sistema con las herramientas que ya utilizas: Google Calendar, Mailchimp, Zapier, Make, y cualquier otra plataforma que necesites. Sincronización perfecta sin duplicar trabajo ni perder información.',
    features: [
      'Integración con Google Calendar y Outlook',
      'Conexión con plataformas de email marketing',
      'APIs personalizadas para tu software',
      'Webhooks y automatizaciones avanzadas'
    ]
  }
};
